class Rotate {
  constructor() {
    this.initialize()
  }

  initialize() {
    window.addEventListener("orientationchange", this.onOrientationChange.bind(this))
  }

  onOrientationChange() {
    if(window.orientation == 90) {
      document.body.style.overflow = 'hidden'
    }
    
    if(window.orientation == 0) {
      document.body.removeAttribute('style')
    }
  }
}

export default Rotate
